// components/admin/quotes/QuoteViewModal.jsx
import { X, User, FileText } from 'lucide-react';
import StatusBadge from './StatusBadge';

export default function QuoteViewModal({
  quote,
  onClose,
  onEdit,
  onSend,
  onStatusChange,
  formatDate,
  formatPrice
}) {
  const statusOptions = [
    { value: 'pending', label: 'En attente' },
    { value: 'sent', label: 'Envoyé' },
    { value: 'accepted', label: 'Accepté' },
    { value: 'declined', label: 'Refusé' },
    { value: 'expired', label: 'Expiré' }
  ];
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Devis {quote.quoteNumber}</h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-content">
          {/* Informations client */}
          <div className="detail-section">
            <h4><User size={18} /> Informations client</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Nom</label>
                <span>{quote.clientName}</span>
              </div>
              <div className="detail-item">
                <label>Entreprise</label>
                <span>{quote.company || 'Non spécifiée'}</span>
              </div>
              <div className="detail-item">
                <label>Email</label>
                <a href={`mailto:${quote.clientEmail}`}>{quote.clientEmail}</a>
              </div>
              <div className="detail-item">
                <label>Téléphone</label>
                <a href={`tel:${quote.phone}`}>{quote.phone}</a>
              </div>
            </div>
          </div>
          
          {/* Détails du projet */}
          <div className="detail-section">
            <h4><FileText size={18} /> Détails du projet</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Type de projet</label>
                <span>{quote.projectType}</span>
              </div>
              <div className="detail-item">
                <label>Budget</label>
                <span>{quote.budgetRange || 'Non spécifié'}</span>
              </div>
              <div className="detail-item">
                <label>Date souhaitée</label>
                <span>{quote.deadline ? formatDate(quote.deadline) : 'Non spécifié'}</span>
              </div>
              <div className="detail-item">
                <label>Statut</label>
                <div className="status-selector">
                  <StatusBadge status={quote.status} />
                  <select 
                    value={quote.status} 
                    onChange={(e) => onStatusChange(e.target.value)}
                    className="status-select"
                  >
                    {statusOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            
            <div className="detail-item full-width">
              <label>Description</label>
              <div className="description-content">
                {quote.projectDescription}
              </div>
            </div>
          </div>
          
          {/* Fonctionnalités */}
          {quote.features && quote.features.length > 0 && (
            <div className="detail-section">
              <h4>Fonctionnalités demandées</h4>
              <div className="features-list">
                {quote.features.map((feature, idx) => (
                  <span key={idx} className="feature-tag">{feature}</span>
                ))}
              </div>
            </div>
          )}
          
          {/* Notes supplémentaires */}
          {quote.additionalNotes && (
            <div className="detail-section">
              <h4>Notes supplémentaires</h4>
              <div className="notes-content">
                {quote.additionalNotes}
              </div>
            </div>
          )}
        </div>
        
        <div className="modal-actions">
          <button onClick={onClose} className="btn-secondary">Fermer</button>
          <button onClick={onEdit} className="btn-primary">Modifier</button>
          <button 
            onClick={onSend} 
            className="btn-success"
            disabled={quote.status === 'sent'}
          >
            Envoyer le devis
          </button>
        </div>
      </div>
    </div>
  );
}